export const platforms = [
  { name: '7Digital', label: '7Digital' },
  { name: 'Amazon', label: 'Amazon' },
  { name: 'Ami Entertainment', label: 'Ami Entertainment' },
  { name: 'Anghami', label: 'Anghami' },
  { name: 'Apple Music', label: 'Apple Music' },
  { name: 'AudibleMagic', label: 'AudibleMagic' },
  { name: 'AudioMack', label: 'AudioMack' },
  { name: 'AWA', label: 'AWA' },
  { name: 'Beatport', label: 'Beatport' },
  { name: 'Bmart', label: 'Bmart' },
  { name: 'Boomplay', label: 'Boomplay' },
  { name: 'Deezer', label: 'Deezer' },
];

export const digitalFingerprintingSystems = [
  { name: '1', label: 'Youtube Content ID' },
  { name: '2', label: 'TikTok Fingerprinting' },
  { name: '3', label: 'Soundcloud' },
  { name: '4', label: 'Facebook/Instagram' },
  { name: '5', label: 'Facebook Fingerprinting' },
  { name: '6', label: 'MusicMatch' },
];
